// 更新数据信息
export const SET_DATA = 'SET_DATA';
// 更新推荐列表
export const SET_LIST = 'SET_LIST';
